import { fetchProducts } from './productDataExcel';

export async function getAllGroups() {
  const products = await fetchProducts();
  const groups = new Set();

  products.forEach(product => {
    if (product.sector) {
      groups.add(product.sector.trim());
    }
  });

  return Array.from(groups).sort();
}

export async function getAllFunctions() {
  const products = await fetchProducts();
  const functions = new Set();

  products.forEach(product => {
    if (product.subsector) {
      product.subsector.split(',').forEach(func => {
        functions.add(func.trim());
      });
    }
  });

  return Array.from(functions).sort();
}

export async function filterProducts(selectedFunction, selectedGroup) {
  const products = await fetchProducts();

  return products.filter(product => {
    const matchesFunction =
      !selectedFunction ||
      product.subsector
        .split(',')
        .some(func => func.trim() === selectedFunction);

    const matchesGroup =
      !selectedGroup || product.sector.trim() === selectedGroup;

    return matchesFunction && matchesGroup;
  });
}
